import { APP_VERSION, COUNTRY_CODE, EnvironmentType } from "./environment.type";

export const environment: EnvironmentType = {
  placement: "prod",
  production: true,
  route_hash: false,
  timezone: "America/Mexico_City",
  code: COUNTRY_CODE.mx,
  currency: "MXN",
  grammar: "es",
  lang: "es",
  phone_length: 10,
  max_tip: 900,
  phone_prefix: "+52",
  gateway: {
    base_url: "https://services.mxgrability.rappi.com",
    csv_prefix: "/api/cargo-api-gateway/csv/portal/",
    gateway_prefix: "/api/cargo-api-gateway/portal/",
    location_gateway_prefix: "/api/cargo-api-gateway/core-maps/address/",
    settlement_prefix: "/api/cargo-api-gateway/portal/settlement/",
    cashless_prefix: "/api/ms/cargo-cashless/",
  },
  logoUrl: "https://cargo-core-api.s3.us-west-2.amazonaws.com/mx/cargo-logos/",
  trackingUrl: "cargo-tracking.rappi.com.mx/",
  aws_location: {
    api_key:
      "v1.public.eyJqdGkiOiIyNWVhOTBlMS0wMWU5LTQwNDEtYjkzZC1mNzdlN2QzYmY0NjIifTJaWEDiMkOVZy_pIVjyDipwiMSy_VAaSTlvIbSguffMmTi-gIusQXwLNTsgf4-RCanTn70KSTidAMsZ2xt1kwlXa7h1XCO2zUiPOVRpU_7wTxuv_HdoLq0-ffiUtJi6pT7KO4jSNrftbh23_umJ-4-XfSOSG7kpGFegNtw8W3yuPUHCqL_u541nm_yspD3IJJPgcmPMq4kEdszp7Noma3kn509POSmHZ_khkw9J_zCxg6MCPx2lXZiGVnc6R6yWXZOenWY7YN23f4StJUifF6c85f_VY2qNYQZwMwCWjWgthS_MOIMcgcRNonYAbl8xRMGWnoyotqZmOXciquqY7lc.ZWU0ZWIzMTktMWRhNi00Mzg0LTllMzYtNzlmMDU3MjRmYTkx",
    region: "us-east-1",
    style: "Standard",
    color_scheme: "Light",
  },
  coordsCenter: { lat: 19.42847, lng: -99.12766 },
  currencySymbol: "$",
  decimalPattern: /^[0-9]+([.]\d{0,0})?$/,
  decimalNumber: 2,
  country: {
    defaultLocale: "es-MX",
  },
  localeUrl: "https://cargo-core-api.s3.amazonaws.com/mx/cargo-logos/",
  auth0: {
    client_id: "hDcAOaY9heMYiAxYPvr5Ynt3ZeNybA43",
    client_secret: "OxnMGuC8OXHjYTgznaaKL2ItdOB4xdMj2jpTDbx6au00NQX47lBEdjgGXc6ia2m4",
    domain: "https://login.partners.rappi.com",
  },
  amplitude: {
    key: "032f00f0dfdad881e7391f28f35156f6",
  },
  i18n_version: APP_VERSION,
  kustomer_assistant_id: "664bbe3419e7a2316b52dc7a",
  recaptcha_site_key: "6Le98o0sAAAAAMT-KoXGJs6OW-aYF9sbNdbigJaR",
  amazon_connect: {
    snippet_id:
      "QVFJREFIaGRXUHpDQ0syTWozT3FtUTlKL1lZeW8zbzdUZEQ4Y1A3d0wzMWFuQ0RFM0FIUjdSZEdzTzJWYWV1Ynl4NjY4QmRCQUFBQWJqQnNCZ2txaGtpRzl3MEJCd2FnWHpCZEFnRUFNRmdHQ1NxR1NJYjNEUUVIQVRBZUJnbGdoa2dCWlFNRUFTNHdFUVFNWXRNZ0JBWUpaUHM2NkhSSkFnRVFnQ3NiNFdUQ0xxSVVDVXBTRldTQzlGU0xSanRhYTFXWm5kMG85RWRBNnB6TDV0bnFRRnQ4V1JlVVhDVGg6OmNGZ0IwVjVrUEhIWlIwNDAyN0ZTTmtMcUpseTYvVlI0enFiSkpCWTVDazQxV3BlTmlKN2V6VDUyblpDYmswMjRlS3NIQnlWN2ZiN3NTNmN3UHBFdjczbGVWRDhkMDlBb25sTGgxUVlGcStIcC9wSVlISDhSa2orSjdDQVIwaEJTZEdNQWJML2g1OXIrZ1RNUWhReXFOSTNDS3puS2RRUT0=",
    src: "https://connect-rappi-support-prod.my.connect.aws/connectwidget/static/amazon-connect-chat-interface-client.js",
    script_id: "37223493-6644-445d-bae1-7074a64d629c",
  },
};
